const MAX_SHOWN = 99

/** The red circle with a number that modern apps put on an icon: unread, new, waiting. Drawn at the icon's top-right corner by the parent's `relative`. */
export function CountBadge({ count, label = 'new' }: { count: number; label?: string }) {
  if (count <= 0) {
    return null
  }
  return (
    <span
      aria-label={`${count} ${label}`}
      className="absolute -top-1 -right-1 min-w-[1.1rem] rounded-full bg-coral px-1 text-center text-[9px] font-bold leading-4 text-white shadow"
    >
      {count > MAX_SHOWN ? `${MAX_SHOWN}+` : count}
    </span>
  )
}
